module.exports = __webpack_public_path__ + "static/media/icomoon.6e80a064.woff";